import React from "react";
import { X } from "lucide-react";

const ConfirmPaymentConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  attendee,
  isLoading = false,
}) => {
  if (!isOpen || !attendee) return null;

  const user = attendee.user || {};
  const title = `${user.first_name || ""} ${user.last_name || ""}`.trim() || "Attendee";
  const attendeeSlug = attendee.slug || attendee.id || attendee.user_slug || "N/A";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div
        className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"
        onClick={onClose}
      />

      <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden">
        <div className="px-6 py-4 bg-gradient-to-r from-emerald-500 to-emerald-600">
          <div className="flex items-start justify-between gap-4">
            <div>
              <h3 className="text-xl font-bold text-white">Payment Confirm</h3>
              <p className="text-emerald-100 text-sm mt-1">
                Confirm the attendee payment and send the invitation email.
              </p>
            </div>
            <button
              onClick={onClose}
              className="text-white hover:text-emerald-200 p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-colors"
              aria-label="Close"
              type="button"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>

        <div className="p-6">
          <div className="bg-gray-50 border border-gray-200 rounded-xl p-4">
            <p className="text-sm text-gray-800">
              <span className="font-semibold">Attendee:</span> {title}
            </p>
            <p className="text-sm text-gray-500 mt-1">
              <span className="font-semibold">ID:</span> {attendeeSlug}
            </p>
          </div>

          <p className="text-sm text-gray-600 mt-4">
            This action will update the attendee status from <strong>Pending Payment</strong> to{" "}
            <strong>Payment Confirmed</strong> and then send the conference invitation email.
          </p>
        </div>

        <div className="px-6 py-4 border-t border-gray-200 bg-gray-50 flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="px-6 py-2 bg-white text-gray-700 rounded-lg border border-gray-300 hover:bg-gray-50 transition-colors font-medium"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isLoading}
            className={`px-6 py-2 rounded-lg font-medium text-white transition-colors ${
              isLoading ? "bg-emerald-400 cursor-not-allowed" : "bg-emerald-600 hover:bg-emerald-700"
            }`}
          >
            {isLoading ? "Confirming..." : "Confirm Payment"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPaymentConfirmModal;

